// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"663":"90119385","938":"ba76101f"}[chunkId] + ".chunk.js";
};